import React, { useState } from 'react'
import { Typography, TextField, Box, useTheme } from '@mui/material'

import { WaitlistFormProps } from './types'
import { TransitionButton } from '../Buttons/TransitionButton'

const WaitlistFormComponent: React.FC<WaitlistFormProps> = ({onSubmit, isLoading}): JSX.Element => {
  const theme = useTheme()
  const [email, setEmail] = useState<string>('')

  const handleSubmit = (): void => {
    console.log(email)
    onSubmit(email)
  }


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        color: 'secondary.main'
      }}
    >
      <Typography
        component="div"
        variant="h5"
        textAlign="center"
        style={{
          margin: theme.spacing(2)
        }}
      >
        Sign up for updates and be notified when we launch.
      </Typography>
      <TextField
        required
        id="outlined-required"
        defaultValue=""
        placeholder="Email Address"
        size="small"
        color="secondary"
        sx={{
          backgroundColor: 'grey.500',
          borderRadius: '5px',
          color: 'secondary.main'
        }}
        inputProps={{
          style: {
            fill: '#DCF6FF',
            background: 'rgb(220, 246, 255)',
            borderRadius: '5px',
            textAlign: 'center',
            letterSpacing: '.25em',
            color: '#000000'
          }
        }}
        style={{
          margin: theme.spacing(1, 4)
        }}
        onChange={handleChange}
      />
      <TransitionButton
        text='Join the Waitlist'
        onClick={handleSubmit}
        variant="contained"
        color="secondary"
        sx={{
          margin: theme.spacing(1, 4, 2, 4),
          textTransform: 'uppercase'
        }}
      />
    </Box>
  )
}

export default WaitlistFormComponent
